export const ProgressItem = ({ items, maxValue }) => {
  if (!items || items.length === 0) {
    return (
      <div className="text-center py-8 text-muted-foreground">
        <p>Asset age profile data not available</p>
      </div>
    );
  }

  const ageColors = [
    "bg-green-500",
    "bg-yellow-500",
    "bg-orange-500",
    "bg-red-500",
  ];

  return (
    <div className="space-y-3">
      {items.map((item, index) => {
        const color = ageColors[index % ageColors.length]; // cycle colors if more items
        const width = `${(item.count / maxValue) * 100}%`; // use maxValue from parent

        return (
          <div key={item.range} className="flex items-center justify-between">
            <span className="text-sm">{item.range}</span>
            <div className="flex items-center gap-2">
              <div className="w-20 h-4 bg-gray-200 rounded">
                <div className={`h-4 ${color} rounded`} style={{ width }}></div>
              </div>
              <span className="text-sm font-medium">{item.count}</span>
            </div>
          </div>
        );
      })}
    </div>
  );
};
